export const particulierStepValidator = [
  ['name', 'project'], // STEP 0
  ['name', 'project', 'location', 'type', 'dateStart'], // STEP 1
  ['name', 'project', 'location', 'type', 'dateStart', 'phone', 'email'], // STEP 2
  ['name', 'project', 'location', 'type', 'dateStart', 'address', 'zipcode', 'city'], // STEP 1 (RDVDOM)
  ['name', 'project', 'location', 'type', 'dateStart', 'address', 'zipcode', 'city', 'phone', 'email'], // STEP 2 (RDVDOM)
];

export const proStepValidator = [
  ['name', 'company', 'proProject'], // STEP 0
  ['name', 'company', 'proProject', 'location', 'type', 'dateStart'], // STEP 1
  ['name', 'company', 'proProject', 'location', 'type', 'dateStart', 'phone', 'email'], // STEP 2
  ['name', 'company', 'proProject', 'location', 'type', 'dateStart', 'address', 'zipcode', 'city'], // STEP 1 (RDVDOM)
  ['name', 'company', 'proProject', 'location', 'type', 'dateStart', 'address', 'zipcode', 'city', 'phone', 'email'], // STEP 2 (RDVDOM)
];
